import {KatalHelper} from "../pages/metrics/KatalHelper";
import {ERROR_METRIC_NAME, JSON_PARSE_METHOD_NAME, PARSING_ERROR_LOG} from "./ConfigConstants";

export function isMapEmpty(map: Map<any, any>) {
    return map ? map.size === 0 : false;
}

export function isNonEmptyList<T>(list: undefined | T[]): list is T[] {
  return (list?.length ?? 0) > 0;
}

export function buildIdValueMap(idValueList: any) {
    return new Map<string, string>(idValueList.map((item: any) => [item.id || item.value, item.label]));
}

export function buildItemIdToItemMap(itemList: any = []) {
    return new Map<string, any>(itemList.map((item: any) => [item.id || item.value, item]));
}

export function getUniqueListBy(arr: any[], key: string) {
    return Array.from(new Map(arr.map(item => [item[key], item])).values())
}

export function isShipmentDelivered(transitStatus: String | undefined) {
    return (transitStatus === "Delivered");
}

export function nullIfBlank(str: string) {
    if(!str || str === "") {
        return null;
    } else {
        return str;
    }
}

export function isNullOrUndefined(value: any) {
  return value === undefined || value === null;
}

export function isEmptyString(str: string | undefined) { return !str || !str.trim() }

export function getNonEmptyValue(str: string | undefined): string | undefined {
  return isEmptyString(str) ? undefined : str;
}

export function getOrDefault(name: string, mapToQuery: Map<String, String>) {
    return mapToQuery.has(name) ? mapToQuery.get(name) : name;
}

export function getItemPropertyValue(item: any, propertyKey: string) {
    return item.itemProperties?.find((property:any) => property?.id?.value === propertyKey)?.value?.valueString;
}

/**
 * Takes physical site as input and return site alphabets and digits)
 * Expected site to follow this regex /^([a-zA-Z]+)(\d+)$/ otherwise this method will return the [original string and null]
 * @param site
 * @returns (string|null)[]
 */
export function getPrefixAlphabetsAndSuffixDigitsFromSite(site: string): (string | null) [] {
    const regexPattern: RegExp =  /^([a-zA-Z]+)(\d+)$/;

    const matches: RegExpMatchArray | null = site.match(regexPattern);

    if (matches === null || matches.length === 0 ) {
        return [site, null];
    }

    return [String(matches[1]), String(matches[2])];

}

export function getQueryParams(link: string): Map<string, string> {
  const paramsMap = new Map<string, string>();

  // Handle case where there's no query string
  if (!link.includes("?")) {
    return paramsMap;
  }
  const queryParams = link.split("?")[1];
  if (!queryParams) {
    return paramsMap;
  }

  queryParams.split("&").forEach(queryParam => {
    let param = queryParam.split("=");
    let key  = param[0];
    let value = param[1].replace("%20", " ");
    paramsMap.set(key, value);
  });
  return paramsMap;
}

export function parseJSON(json: string, katalMetricHelper: KatalHelper, extraLog: string) {

  try {
    return JSON.parse(json);
  } catch (e) {
    let errorMessage = PARSING_ERROR_LOG(json, extraLog, e);
    katalMetricHelper.logError(errorMessage);
    katalMetricHelper.emitCountMetrics(ERROR_METRIC_NAME, JSON_PARSE_METHOD_NAME, 1);
  }
}